/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import CModalWindow from '../common/modal/modalWindow.component.container';
import Loading from '../loading/loading.component';
import Notification from '../common/notification/notification.component';
import * as consts from '../../const.js';
import PropTypes from 'prop-types';
import PdfService from './pdf.service';
import { Button, Clickable } from 'tc-client-common';

class PdfModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cWidth: 0
    };

    this.documentName = this.props.documentName;
    this.closePdf = this.closePdf.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.updateWidth = this.updateWidth.bind(this);
  }
  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateWidth();
    window.addEventListener('resize', this.updateWidth);
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth);
  }
  container = null;

  updateWidth() {
    if (this.container) {
      this.setState({ cWidth: this.container.clientWidth });
    }
  }

  click(e) {
    e && e.click(); //simulated click to hide the dropdown menu
  }

  closePdf() {
    this.props.closePdf();
    this.pdf = '';
  }

  downloadPdf() {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(this.props.objectBlob);
    } else {
      const blobUrl = window.URL.createObjectURL(this.props.objectBlob);
      let fileName = this.documentName + '.pdf';
      let link = document.createElement('a');
      link.setAttribute('href', blobUrl);
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    }
  }

  render() {
    const { pdfArrayBuffer, isFetchingPdf, pdfError, isIE, browserVersion } = this.props;
    const supportPdf = !(isIE && parseInt(browserVersion) < 11);
    let notification = <span />,
      errorStyle = pdfError ? 'pdf-error' : '';

    if (isFetchingPdf) {
      notification = <Loading />;
    }

    if (supportPdf) {
      if (pdfArrayBuffer && this.container) {
        PdfService.renderPages(pdfArrayBuffer, this.container);
      }
    }

    if (!supportPdf) {
      notification = (
        <div className="no-support-pdf">
          <div className="no-support-background">
            <h3 className="no-support-pdf-message">{consts.PDF_BROWSER_SUPPORT_WARNING}</h3>

            <Clickable className="button-common button-default large-button get-pdf" onClick={this.downloadPdf}>
              <i className="material-icons material-get-pdf">get_app</i>
            </Clickable>
          </div>
        </div>
      );
    }

    if (pdfError) {
      notification = <Notification type="error" data={consts.PRINT_DOCUMENT_ERROR_MESSAGE} />;
    }

    return (
      <div id="pdf-modal" className="pdf-modal-component">
        <div className={`${errorStyle} pdf-toolbar`}>
          {supportPdf && (
            <div className="pdf-toolbar-btns">
              <Clickable
                id="download-pdf-btn"
                classes="button-common button-default large-button download-pdf"
                onClick={this.downloadPdf}
              >
                <span>{consts.DOWNLOAD}</span>
                <i className="material-icons">get_app</i>
              </Clickable>
            </div>
          )}
        </div>

        <div id="pdf-viewer" className={`${errorStyle} pt-modal-pdf-holder`} ref={this.click}>
          {supportPdf && (
            <div
              className="pdf-canvas"
              ref={(cont) => {
                this.container = cont;
              }}
            />
          )}
          {notification}
        </div>
        <div className="pt-modal-pdf-menu">
          <Button theme="default large-button" handleClick={this.closePdf} label={consts.CLOSE} />
        </div>
      </div>
    );
  }
}

PdfModal.propTypes = {
  pdfArrayBuffer: PropTypes.object,
  objectBlob: PropTypes.object,
  pdfError: PropTypes.object,
  isFetchingPdf: PropTypes.bool,
  closePdf: PropTypes.func,
  browserVersion: PropTypes.string,
  isIE: PropTypes.bool,
  documentName: PropTypes.string
};

export default PdfModal;
